<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card>
          <l-data-table
            title-text="短信模板列表"
            :headers="header"
            :get-data-func="getSmsMessageList"
            :filter-items="filterItems"
            search-text="搜索模板">
            <template slot="row-action" slot-scope="{item}">
              <v-btn icon>
                <v-tooltip left>
                  <v-btn
                    @click="sendDialog = {activate: true, item: item}"
                    icon
                    slot="activator"
                  >
                    <v-icon small>mdi-email</v-icon>
                  </v-btn>
                  <span>以此模板发送</span>
                </v-tooltip>
              </v-btn>
            </template>
          </l-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog max-width="800px" persistent scrollable v-model="sendDialog.activate">
      <send-sms-message-content
        :action-loading="sendLoading"
        :item="sendDialog.item"
        @cancel="sendDialog = {activate: false, item: {}}"
        @send="sendMessage"
        v-if="sendDialog.activate"
      ></send-sms-message-content>
    </v-dialog>
  </v-container>
</template>
<script>
import {time} from '../../../ladmin/utils/time'
import LDataTable from '../../../ladmin/components/LDataTable/LDataTable'
import LFixedBtn from '../../../ladmin/components/LFixedBtn/LFixedBtn'
import sendSmsMessageContent from './sendSmsMessageContent'
export default {
  name: 'templateList',
  components: {LFixedBtn, LDataTable, sendSmsMessageContent},
  data () {
    return {
      selected: [],
      header: [
        {text: '模板标题', value: 'name', align: 'left'},
        {text: '模板类型', value: 'type', align: 'right'},
        {text: '模板内容', value: 'originalTemplate', align: 'right', maxWidth: '28em', tooltip: true},
        {text: '操作人', value: 'editor', align: 'right'},
        {text: '添加时间', value: 'creationTime', align: 'right'},
        {text: ' ', value: '', sortable: false, width: '80px'}
      ],
      filterItems: [
        {
          prependIcon: 'mdi-bookmark',
          key: 'moduleType',
          value: '',
          label: '模板类型',
          type: 'select',
          items: [{text: '短信模板', value: 'sms'},],
          itemValue: 'value',
          itemText: 'text',
          layout: ['xs12', 'sm4'],
        },
        {
          prependIcon: 'mdi-view-grid',
          key: 'module',
          value: '',
          label: '所属模块',
          type: 'select',
          items: [],
          itemValue: 'value',
          itemText: 'text',
          layout: ['xs12', 'sm4'],
        },
        {
          key: 'creationTime',
          value: {},
          label: '添加日期',
          type: 'duration',
          layout: ['xs12', 'sm4'],
          f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
          range: true
        },
      ],
      sendDialog: {
        activate: false,
        item: {}
      },
      sendLoading: false
    }
  },
  created () {
    this.getModuleList()
  },
  computed: {
    moduleList () {
      return this.$store.state.messageManagement.moduleList
    }
  },
  methods: {
    async getModuleList () {
      let res = await this.$store.dispatch('messageManagement/getModuleList')
      let items = []
      for (var i in res.data.data) {
        let obj = {
          value: i,
          text: res.data.data[i]
        }
        items.push(obj)
      }
      this.$store.commit('messageManagement/setModuleList', items)
      this.filterItems[1].items = this.moduleList
    },
    async getSmsMessageList ({pagination, sortStack, filterItems = [], search}) {
      let searchParam = {
        'searchParam': {
          'type': {
            'keyword': 'sms',
            'order': 'ASC'
          },
          'module': {
            'keyword': filterItems[1].value,
            'order': 'ASC'
          },
          'name': {
            'keyword': search,
            'order': 'ASC'
          },
        }
      }
      let res = await this.$store.dispatch('messageManagement/getTemplateList', {pagination: pagination, searchParam: searchParam})
      if (res.data.status === 1) {
        return {items: res.data.data.content, amount: res.data.data.totalElements}
      }
      else {
        this.$L.alert('error', {message: '查询失败，原因:' + res.data.msg})
      }
    },
    async sendMessage (item) {
      this.sendLoading = true
      let res = await this.$store.dispatch('messageManagement/sendSmsMessage', item)
      console.log(res)
      this.sendLoading = false
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '发送成功'})
      }
      else {
        this.$L.alert('error', {message: '发送失败，原因：' + res.data.msg})
      }
    }
  }
}
</script>
